<template>
    <div class>
        <search-form :formConfig="formConfig" :source="searchData" @handleSearchJsf="handleSearchJsf"
            @handleSearchKlf="handleSearchKlf" @search="search">
        </search-form>
        <div class="table-common">
            <a-table size="middle" :columns="columns" :row-key="record => record.id" :data-source="tableData"
                :pagination="pagination" :loading="loading" bordered :scroll="columns.length > 10 ? { x: '100%' } : {}"
                :locale="{ emptyText: '暂无数据' }" @change="handleTableChange">
                <template slot="guarantorName" slot-scope="text,record">
                    <span v-if="record.guarantorName">
                        {{ record.guarantorName }}
                    </span>
                    <span v-else>--</span>
                </template>
                <template slot="thsFncAmt" slot-scope="text">{{ text | splitK }}</template>
                <template slot="canBeModified" slot-scope="text">{{ text | GbCbmTrans }}</template>
                <template slot="aplyDsbrDay" slot-scope="text">{{ text | dateFormat("YYYY-mm-dd") }}</template>
                <template slot="fncExDt" slot-scope="text">{{ text | dateFormat('YYYY-mm-dd') }}</template>
                <template slot="fnsStCd" slot-scope="text,record">
                    <div class="spaceCenter">
                        {{ text | dictFilter(dict.financeStatus) }}
                        <a-popover title="拒绝原因">
                            <template slot="content">
                                <div style="color:#666;max-width:200px;">
                                    {{ record.fnsStCd == 13 ? record.opin : record.fundOpinion }}</div>
                            </template>
                            <!-- 平台审核已拒绝、资方审批拒绝 -->
                            <svg v-if="record.fnsStCd == 13 || record.fnsStCd == 10" class="payable-icon"
                                aria-hidden="true">
                                <use xlink:href="#gold-icon-tishi"></use>
                            </svg>
                        </a-popover>
                    </div>
                </template>
                <template slot="operation" slot-scope="text,record">
                    <a @click="toPageDetail(record)">详情</a>
                    <a @click="toLoanedDetail(record)" v-if="tabType == 'borrowLoaned'">放款信息</a>
                </template>
            </a-table>
            <div :class="{ 'table-total': pagination.total > 0, 'table-total-none': pagination.total == 0 }">
                共有记录：
                <span class="text-color-blue">{{ pagination.total }} 条</span>融资金额：
                <span class="text-color-orange">{{ totalPayable(tableData) | splitK }} 元</span>
            </div>
        </div>
        <loanedDetailDialog ref="loanedDetailDialog" />
    </div>
</template>

<script>
import { findGoldEstbOrRcPtyOrPypt } from "@/api/gold.js"
import { mapState, mapGetters, mapActions, mapMutations } from "vuex"
import { selectTenant } from "@/api/login.js"
import { financeQuery } from "@/api/loan.js"
import loanedDetailDialog from "./loanedDetailDialog.vue"
export default {
    props: ["nsStCd", "pcsStCd", "fnsStCd", "tabType"],
    components: { loanedDetailDialog },
    data() {
        return {
            searchData: {
                aplyDsbrDay: [],
                estb: {},
                receiver: {},
                exDay: [],
                gldId: "",
                canBeModified: [],
                financingStatus: ""
            },
            formConfig: [
                {
                    prop: "aplyDsbrDay",
                    label: "申请日期",
                    type: "dateRange"
                },
                {
                    prop: "gldId",
                    type: "input",
                    label: "祺信编号",
                },
                {
                    prop: "estb",
                    type: "selectSearch",
                    label: "开立方",
                    option: [],
                    searchSource: true,
                    headNameFirst: "开立方名称",
                    headNameSecond: "社会信用代码",
                    valuePorp: "orgCode",
                    valuePorpReal: "cstId",
                    labelPorp: "cstNm",
                    searchHandle: "handleSearchKlf",
                },
                {
                    prop: "receiver",
                    type: "selectSearch",
                    label: "资金方",
                    option: [],
                    searchSource: true,
                    headNameFirst: "资金方名称",
                    headNameSecond: "社会信用代码",
                    valuePorp: "tenantId",
                    labelPorp: "tenantName",
                    normal: true,
                    searchHandle: "handleSearchJsf",
                },
                {
                    prop: "exDay",
                    type: "dateRange",
                    label: "到期日期",
                },

                {
                    prop: "canBeModified",
                    type: "select",
                    label: "变更状态",
                    option: this.dict.modifiedStatus,
                    mode: "multiple",
                    defaultProps: {
                        value: "value",
                        label: "name"
                    }
                },
                {
                    hide: this.tabType != "borrowAll",
                    prop: "fnsStCd",
                    type: "select",
                    label: "融资状态",
                    option: this.dict.financeStatus,
                    defaultProps: {
                        value: "value",
                        label: "name"
                    }
                },

            ],
            tableData: [],
            columns: [
                {
                    title: "申请日期",
                    sorter: true,
                    dataIndex: "aplyDsbrDay",
                    scopedSlots: { customRender: "aplyDsbrDay" },
                },
                {
                    title: "祺信编号",
                    dataIndex: "gldId"
                },
                {
                    title: "开立方",
                    dataIndex: "cntprNm"
                },
                {
                    title: " 担保方",
                    dataIndex: "guarantorName",
                    scopedSlots: { customRender: "guarantorName" },
                },
                {
                    title: "资金方",
                    dataIndex: "tenantNm"
                },
                {
                    title: "融资金额(元)",
                    dataIndex: "thsFncAmt",
                    sorter: true,
                    scopedSlots: { customRender: "thsFncAmt" },
                },
                {
                    title: "到期日期",
                    sorter: true,
                    dataIndex: "fncExDt",
                    sorter: true,
                    scopedSlots: { customRender: "fncExDt" },
                },
                {
                    title: "变更状态",
                    dataIndex: "canBeModified",
                    scopedSlots: { customRender: "canBeModified" },
                },
                {
                    title: "融资状态",
                    dataIndex: "fnsStCd",
                    hide: this.tabType != 'borrowAll',
                    algin: "left",
                    scopedSlots: { customRender: "fnsStCd" },
                },
                {
                    title: "操作",
                    dataIndex: "operation",
                    scopedSlots: { customRender: "operation" },
                }
            ],
            pagination: {
                pageSize: 10,
                current: 1,
                sortField: "rcvbExDat",
                sortOrder: "ascend",
                total: 0,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['5', '10', '20', '50', '100'],
                showTotal: (total) => {
                    return `共 ${total} 条`
                }
            },
            loading: false,
        };
    },
    computed: {
        ...mapGetters({
            userObj: "home/getUserObj"
        })
    },
    methods: {
        handleSearchJsf(value, data, cfg) {
            this.getDataListTenant(value, cfg);
        },
        handleSearchKlf(value, data, cfg) {
            this.getDataList(value, '', cfg);
        },
        getDataList(value, param = {}, cfg) { //下拉筛选
            const cstIds = this.userObj.cstIds.join(",");
            findGoldEstbOrRcPtyOrPypt({
                cstNm: value,
                pageNum: 1,
                pageSize: 10,
                queryType: 4,
                cstIds: cstIds
            }).then((res) => {
                const index = this.formConfig.findIndex(item => item.prop == cfg.prop);
                if (res.data && res.data.grid) {
                    this.formConfig[index].option = res.data.grid.list || [];
                } else {
                    this.formConfig[index].option = []
                }
            })
                .catch((error) => {
                    console.log(error);
                });
        },
        getDataListTenant(value, cfg) { //下拉筛选
            selectTenant({
                tenantName: value,
                pageSize: 10,
                tenantName: value || "",
                pageNum: 1,
            }).then((res) => {
                const index = this.formConfig.findIndex(item => item.prop == cfg.prop);
                if (res.data && res.data.grid) {
                    this.formConfig[index].option = res.data.grid.list || [];
                } else {
                    this.formConfig[index].option = []
                }
            })
                .catch((error) => {
                    console.log(error);
                });
        },
        search(data) {
            this.searchData = data;
            this.getTableData();
        },
        totalPayable(list) {
            return list.reduce((acc, rec) => {
                return acc + (+rec["thsFncAmt"] || 0);
            }, 0);
        },
        handleTableChange(pagination, filters, sorter) { //表格排序回调
            this.pagination = {
                current: pagination.current,
                pageSize: pagination.pageSize,
                sortField: sorter.field,
                sortOrder: sorter.order,
                total: this.pagination.total || 0,
            };
            this.getTableData();
        },
        getTableData() {
            let params = {};
            let isMore = false;
            if (this.pcsStCd) {
                isMore = this.pcsStCd.length > 1;
            }
            const order = this.pagination.sortOrder == "ascend" ? "asc" : "desc";
            params = {
                aplyDsbrDayOrder: this.pagination.sortField == "aplyDsbrDay" ? order : null,
                thsFncAmtOrder: this.pagination.sortField == "thsFncAmt" ? order : null,
                fncExDtOrder: this.pagination.sortField == "fncExDt" ? order : null,
                nsStCd: this.nsStCd,
                pcsStCd: isMore ? undefined : this.pcsStCd,
                pcsStCds: isMore ? this.pcsStCd : undefined,
                fnsStCd: this.fnsStCd ? this.fnsStCd : this.searchData.fnsStCd,
                fncJrnlId: this.searchData.fncJrnlId,
                estb: this.searchData.estb.key,
                tenantId: this.searchData.receiver.key,
                gldId: this.searchData.gldId,
                canBeModified: this.searchData.canBeModified && this.searchData.canBeModified.length > 0 ? this.searchData.canBeModified.join(",") : null,
                fncStartDt: this.searchData.aplyDsbrDay[0],
                fncEndDt: this.searchData.aplyDsbrDay[1],
                fncExDtStart: this.searchData.exDay[0],
                fncExDtEnd: this.searchData.exDay[1],
                pageNum: this.pagination.current,
                pageSize: this.pagination.pageSize,
            };

            this.loading = true;
            financeQuery(params)
                .then((res) => {
                    this.pagination.total = res.data.grid.total;
                    let list = res.data.grid.list;
                    this.tableData = list;
                    this.loading = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                });
        },
        toPageDetail(data) {
            this.MENUAPI.goToOneTab({
                path: "circulation/borrow/details/" + data.fncJrnlId,

            });
        },
        // 查看放款信息
        toLoanedDetail(data) {
            this.$refs.loanedDetailDialog.open(data);
        }

    },
    created() {
        this.formConfig = this.formConfig.filter(i => !i.hide);
        this.columns = this.columns.filter(i => !i.hide);
        this.getTableData();
    },
    mounted() { },
    activated() { },
};
</script>
<style scoped>
.payable-icon {
    width: 17px;
    height: 17px;
    margin-left: 4px;
    position: relative;
    top: -1px;
}
</style>



// WEBPACK FOOTER //
// src/pages/circulation/gold-financing/gold-financing-query.vue